import React, {useState} from 'react';
import {InstanceContext} from '../../../../InstanceContext';
import {UserContext} from '../../../../Context/UserContext';
import {SearchFetch} from '@xpertdox_js/xdcomponents';
import axiosConfig from '../../../../config/axios.config';

const TrialSearch = props => {

  const {instanceContext} = React.useContext(InstanceContext);
  const {user} = React.useContext(UserContext);
  const [results, setResults] = useState(null);

  const resultHandler = searchResults => {
    // console.log(searchResults, 'results');
    let parsedResults = searchResults.map(result => ({
      title: result._id,
      text: result._source.title1,
      value: result,
    }))
    setResults(parsedResults);
  }

  // click on option
  const handleClick = value => {
    // console.log(value, 'value on click');
    props.addTrial(value);
    setResults(null)
  }

  const url = `https://p-api.xpertdox.com/rt/search/trials/nct${
    props.master ? (instanceContext || user.instance).toLowerCase() : 'master'
  }`;

  return(
    <div>
      <SearchFetch
        axiosConfig={axiosConfig}
        url={url}
        method={'get'}
        items={results}
        handleResult={resultHandler}
        handleSelect={handleClick}
        addTermToEnd='query'
        label='Search trials to add to email'
        placeholder='Search Trials...'
      />
    </div>
  )
}

export default TrialSearch;
